import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Button from '../components/ui/Button';

const HomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');

  const templates = [
    { id: 'bakkal', icon: 'shopping_cart', category: 'retail' },
    { id: 'kurban', icon: 'volunteer_activism', category: 'nonProfit' },
    { id: 'klinik', icon: 'local_pharmacy', category: 'service' },
    { id: 'insaat', icon: 'construction', category: 'service' },
    { id: 'restoran', icon: 'restaurant', category: 'retail' },
    { id: 'nakliye', icon: 'local_shipping', category: 'service' },
    { id: 'dugun', icon: 'celebration', category: 'service' },
    { id: 'pazarlama', icon: 'campaign', category: 'service' },
    { id: 'devletGider', icon: 'account_balance', category: 'nonProfit' },
    { id: 'kamuMalAlim', icon: 'inventory', category: 'nonProfit' },
    { id: 'ofisGider', icon: 'business', category: 'service' },
    { id: 'terzi', icon: 'checkroom', category: 'retail' },
    { id: 'egitim', icon: 'school', category: 'service' },
    { id: 'otoTamir', icon: 'build', category: 'service' },
    { id: 'lokalOrganizasyon', icon: 'event', category: 'service' },
    { id: 'yerelYonetim', icon: 'location_city', category: 'nonProfit' }
  ];

  const filteredTemplates = templates.filter(template => {
    const matchesSearch = t(`templates.${template.id}.title`).toLowerCase().includes(searchTerm.toLowerCase()) ||
                          t(`templates.${template.id}.description`).toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = activeFilter === 'all' || template.category === activeFilter;
    return matchesSearch && matchesFilter;
  });

  const handleTemplateSelect = (templateId) => {
    navigate(`/report/${templateId}`);
  };

  // Navbar'da About ve Feedback için yönlendirme
  const handleNav = (path) => {
    navigate(path);
  };

  return (
    <div className="relative flex h-auto min-h-screen w-full flex-col bg-background-light dark:bg-background-dark">
      <Header />
      
      <main className="flex flex-1 justify-center py-5 px-4 sm:px-6 lg:px-8">
        <div className="layout-content-container flex flex-col w-full max-w-6xl flex-1 gap-6">
          <div className="flex flex-wrap justify-between gap-3 p-4">
            <div className="flex min-w-72 flex-col gap-3">
              <p className="text-[#111418] dark:text-white text-4xl font-black leading-tight tracking-[-0.033em]">
                {t('home.title')}
              </p>
              <p className="text-gray-600 dark:text-gray-400 text-base font-normal leading-normal">
                {t('home.subtitle')}
              </p>
            </div>
          </div>

          <div className="px-4 py-3">
            <label className="flex flex-col min-w-40 h-14 w-full">
              <div className="flex w-full flex-1 items-stretch rounded-xl h-full shadow-sm">
                <div className="text-gray-600 dark:text-gray-400 flex border-none bg-white dark:bg-gray-800 items-center justify-center pl-4 rounded-l-xl border-r-0">
                  <span className="material-symbols-outlined">search</span>
                </div>
                <input
                  className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] dark:text-white focus:outline-0 focus:ring-2 focus:ring-primary/50 border-none bg-white dark:bg-gray-800 h-full placeholder:text-gray-400 px-4 rounded-l-none border-l-0 pl-2 text-base font-normal leading-normal"
                  placeholder={t('home.search')}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </label>
          </div>

          <div className="flex gap-3 px-4 overflow-x-auto pb-2 flex-wrap">
            <button
              onClick={() => setActiveFilter('all')}
              className={`flex h-10 shrink-0 cursor-pointer items-center justify-center gap-x-2 rounded-lg pl-3 pr-4 ${
                activeFilter === 'all' ? 'bg-primary text-white shadow-sm' : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700'
              }`}
            >
              <span className="material-symbols-outlined text-base">apps</span>
              <p className="text-sm font-medium leading-normal">{t('home.allCategories')}</p>
            </button>
            <button
              onClick={() => setActiveFilter('retail')}
              className={`flex h-10 shrink-0 cursor-pointer items-center justify-center gap-x-2 rounded-lg pl-3 pr-4 ${
                activeFilter === 'retail' ? 'bg-primary text-white shadow-sm' : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700'
              }`}
            >
              <span className="material-symbols-outlined text-base">storefront</span>
              <p className="text-sm font-medium leading-normal">{t('home.retail')}</p>
            </button>
            <button
              onClick={() => setActiveFilter('service')}
              className={`flex h-10 shrink-0 cursor-pointer items-center justify-center gap-x-2 rounded-lg pl-3 pr-4 ${
                activeFilter === 'service' ? 'bg-primary text-white shadow-sm' : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700'
              }`}
            >
              <span className="material-symbols-outlined text-base">design_services</span>
              <p className="text-sm font-medium leading-normal">{t('home.service')}</p>
            </button>
            <button
              onClick={() => setActiveFilter('nonProfit')}
              className={`flex h-10 shrink-0 cursor-pointer items-center justify-center gap-x-2 rounded-lg pl-3 pr-4 ${
                activeFilter === 'nonProfit' ? 'bg-primary text-white shadow-sm' : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700'
              }`}
            >
              <span className="material-symbols-outlined text-base">volunteer_activism</span>
              <p className="text-sm font-medium leading-normal">{t('home.nonProfit')}</p>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
            {filteredTemplates.map((template) => (
              <div
                key={template.id}
                className="flex flex-col gap-4 p-5 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm transition-all hover:shadow-lg hover:-translate-y-1 card-hover"
              >
                <div className="flex items-center gap-4">
                  <div className="flex items-center justify-center size-12 rounded-lg bg-primary/10 text-primary">
                    <span className="material-symbols-outlined text-3xl">{template.icon}</span>
                  </div>
                  <div>
                    <p className="text-[#111418] dark:text-white text-base font-bold leading-normal">
                      {t(`templates.${template.id}.title`)}
                    </p>
                    <p className="text-gray-600 dark:text-gray-400 text-sm font-normal leading-normal">
                      {t(`templates.${template.id}.description`)}
                    </p>
                  </div>
                </div>
                <Button
                  onClick={() => handleTemplateSelect(template.id)}
                  variant="primary"
                  fullWidth
                >
                  {t('form.useTemplate')}
                </Button>
              </div>
            ))}
          </div>

          {filteredTemplates.length === 0 && (
            <div className="text-center py-12">
              <span className="material-symbols-outlined text-6xl text-gray-300 dark:text-gray-600">search_off</span>
              <p className="mt-4 text-gray-500 dark:text-gray-400">No templates found matching your search.</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
